export const personRoles = {
  SUPER_ADMIN: 1,
  ADMIN: 2,
  DRIVER: 3,
};
